<template>
  <div @click="handleRedirect" :class="cardClass" :style="{ height: height + 'rem', width: width + 'rem' }"
    class="bg-primary-light text-primary card-container px-6 py-16 rounded-2xl overflow-hidden">
    <div class="card-image-wrapper">
      <IconControl :style="{ margin: margin + 'px' }" v-if="icon_id && icon_width && icon_height" :id="icon_id" :width="icon_width"
        :height="icon_height" />
    </div>
    <div class="text-center font-bold uppercase">
      <h2 :style="{ fontSize: fontSize + 'px' }">{{ title }}</h2>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconControl from './IconControl.vue';
import mixin from '@/mixins/controls.js';

export default {
  name: 'v-card',
  mixins: [mixin],
  components: {
    IconControl
  },
  props: {
    square: {
      type: Boolean,
    },
    rectangle: {
      type: Boolean,
    },
    imageSrc: {
      type: String,
    },
    title: {
      type: String,
    },
    icon_id: {
      type: String,
    },
    icon_width: {
      type: Number,
    },
    icon_height: {
      type: Number,
    },
    height: {
      type: Number,
    },
    width: {
      type: Number,
    },
    fontSize: {
      type: Number,
      default: 48, // Default font size
    },
    margin: {
      type: Number,
      default: 10,
    }
  },
  computed: {
    cardClass() {
      return {
        'flex flex-col items-center justify-center': this.square,
        'flex flex-row items-center justify-start': this.rectangle,
        'h-full': true,
        'w-full': true,
      };
    },
  },
  methods: {
    handleRedirect() {
    if (this.redirect_to) {
      this.$router.push(this.redirect_to);
    }
  }
}

};
</script>

<style scoped>
.card-container {
  margin: 10px auto;
  display: flex;
  flex-direction: column;
}

.card-container.flex.flex-row {
  flex-direction: row;
}


.card-container.flex.flex-row .card-title {
  flex-grow: 1;
  padding-left: 20px;
  text-align: left;
}


.card-container.flex.flex-col .card-title {
  padding-top: 15px;
}
</style>
